<template>
  <div class="payout-list">
    <PendingPayoutList></PendingPayoutList>
    <CompletedPayoutList></CompletedPayoutList>
  </div>
</template>

<script>
  import PendingPayoutList from './PendingPayoutList.vue'
  import CompletedPayoutList from './CompletedPayoutList.vue'

  export default {
    name: 'PayoutList',

    components: {
      PendingPayoutList,
      CompletedPayoutList
    },
  }
</script>
